import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { useNativeEvents } from 'hooks/useNativeEvents';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { cloudflareUrl } from 'utilities/cloudflareImageResizer';

interface SmartBannerProps {
  type: string;
}

export const SmartBanner: FunctionComponent<SmartBannerProps> = (props) => {
  const { nativeUrlSchemeLink } = useNativeEvents();
  const channel = useSelector(
    (state: RootState) => state.channel.channelDetails
  );

  const bannerLink = nativeUrlSchemeLink('channel', props.type, {
    url: window.location.href,
    channel_url: window.location.origin,
    channel_name: channel?.username,
    channel_theme_color: channel?.themeColor,
    channel_logo_url: cloudflareUrl(channel?.logoKey, {
      width: 100,
      quality: 80,
      baseUrl: process.env.REACT_APP_STORAGE_CDN_URL
    })
  });

  return (
    <Helmet>
      <meta
        name="apple-itunes-app"
        content={`app-id=${process.env.REACT_APP_APPLE_APP_ID}, app-argument=${bannerLink}`}
      />
    </Helmet>
  );
};
